<template>
  <el-container>
    <el-header>
      <el-row type="flex" align="middle">
        <el-col style="line-height: 60px;">
          <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
          <el-button round @click="createClick">{{generateCustomizeString('createNewCoupon')}}</el-button>
          <el-tag style="margin-left: 10px;">
            {{generateCustomizeString('collectCoupon')}}:
            <a
              :href="mobileUrl + '/coupon-collect'"
              target="_blank"
            >{{ mobileUrl + '/coupon-collect' }}</a>
          </el-tag>
          <el-tag style="margin-left: 10px;">
            {{generateCustomizeString('pcCollectCoupon')}}:
            <a
              :href="pcUrl + '/coupon'"
              target="_blank"
            >{{ pcUrl + '/coupon' }}</a>
          </el-tag>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-form :inline="true" ref="searchForm" :model="searchForm" class="search-form-inline">
            <el-form-item :label="generateCustomizeString('couponName')">
              <el-input
                v-model="searchForm.title"
                :placeholder="generateCustomizeString('couponName')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('couponExpiryTime')">
              <el-date-picker
                v-model="searchForm.expired_at"
                type="datetime"
                :placeholder="generateCustomizeString('couponExpiryTime')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">{{generateCustomizeString('search')}}</el-button>
              <el-button @click="onReset">{{generateCustomizeString('reset')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="couponData" v-loading="loading" style="width: 100%; margin-bottom:60px;">
        <el-table-column prop="title" :label="generateCustomizeString('couponName')"></el-table-column>
        <el-table-column prop="code" :label="generateCustomizeString('couponCode')"></el-table-column>
        <el-table-column :label="generateCustomizeString('effectiveTime')" width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.begin_at | toLocalTime}}</div>
            <div>To</div>
            <div>{{ scope.row.expired_at | toLocalTime}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="type" :label="generateCustomizeString('couponType')"></el-table-column>
        <el-table-column prop="count" :label="generateCustomizeString('numberOfIssues')"></el-table-column>
        <el-table-column :label="generateCustomizeString('couponDetails')" width="170">
          <template slot-scope="scope">
            <span
              v-if="scope.row.type === '抵扣'"
            >{{ generateCustomizeString('infoCondition') + scope.row.full_threshold + generateCustomizeString('infoDeduction') + scope.row.reduction * 100 / 10000 }}</span>
            <span
              v-else
            >{{ generateCustomizeString('infoCondition') + scope.row.full_threshold + generateCustomizeString('infoDiscount') + scope.row.reduction / 10 + generateCustomizeString('infoSale') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('showInCollection')" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.show_in_center"
              :active-value="1"
              :inactive-value="0"
              @change="editCouponShowInCenter(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('status')" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enabled"
              :active-value="1"
              :inactive-value="0"
              @change="editCouponStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="comment" :label="generateCustomizeString('couponRemark')"></el-table-column>
        <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="100">
          <template slot-scope="scope">
            <div>
              <el-button
                size="medium"
                @click="editClick(scope.row)"
                type="text"
              >{{generateCustomizeString('details')}}</el-button>
            </div>
            <div>
              <el-button
                size="medium"
                @click="viewStatistics(scope.row)"
                type="text"
              >{{generateCustomizeString('couponStatistics')}}</el-button>
            </div>
            <div>
              <el-button
                size="medium"
                @click="onRemove(scope.row)"
                type="text"
              >{{generateCustomizeString('delete')}}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="generateCustomizeString('deleteCoupon')"
        :visible.sync="dialogVisible"
        width="30%"
        :append-to-body="true"
      >
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{generateCustomizeString('deleteCancel')}}</el-button>
          <el-button
            type="primary"
            @click="deleteCoupon()"
          >{{generateCustomizeString('deleteConfirm')}}</el-button>
        </span>
      </el-dialog>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:10px;">
      <el-row type="flex">
        <el-col style="padding-top: 5px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfCoupons"
            layout="total, prev, pager, next"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

const originCouponSearchFrom = {
  title: '',
  expired_at: ''
}

export default {
  name: 'CouponList',
  data() {
    return {
      mobileUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : process.env.VUE_APP_MOBILE_URL +
          this.$store.state.shop.shop_domain_prefix,
      pcUrl: this.$store.state.shop.shop_pc_url,
      searchForm: Object.assign({}, originCouponSearchFrom),
      loading: false,
      couponData: [],
      filters: {},
      agentListLoading: false,
      currentPage: 1,
      currentTotal: 0,
      numOfCoupons: 15,
      dialogVisible: false,
      selectDeleteId: null
    }
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.onRefersh()
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchCouponList(this.currentPage)
    },
    createClick() {
      this.$router.push({ name: 'CreateCoupon' })
    },
    onSearch() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          if (this.searchForm.expired_at) {
            var date = dayjs(this.searchForm.expired_at)
              .utc()
              .format('YYYY-MM-DD HH:mm:ss')
            params.expired_at = date
          }
          console.log(params)
          this.filters = params
          this.fetchCouponList(1)
        } else {
          console.log('data error')
        }
      })
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.searchForm = Object.assign({}, originCouponSearchFrom)
      this.filters = {}
      this.fetchCouponList(1)
    },
    editClick(row) {
      this.$router.push({
        name: 'EditCoupon',
        params: { couponId: row.id }
      })
    },
    viewStatistics(row) {
      this.$router.push({
        name: 'CouponStatistics',
        params: { couponId: row.id }
      })
    },
    onRemove(row) {
      this.selectDeleteId = row.id
      this.dialogVisible = true
    },
    deleteCoupon() {
      if (this.selectDeleteId === 0) return
      request({
        url: 'coupon/' + this.selectDeleteId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchCouponList()
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    },
    fetchCouponList(page) {
      this.loading = true
      request({
        url: '/coupon/list',
        method: 'get',
        params: {
          page: page,
          ...this.filters,
          page_size: this.numOfCoupons
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.title = response.data[i].title
            obj.code = response.data[i].code
            obj.begin_at = response.data[i].begin_at
            obj.expired_at = response.data[i].expired_at
            if (response.data[i].type === 0) {
              obj.type = this.generateCustomizeString('deduction')
            } else {
              obj.type = this.generateCustomizeString('discount')
            }
            obj.count = response.data[i].count
            obj.full_threshold = (response.data[i].full_threshold * 100) / 10000
            obj.reduction = response.data[i].reduction
            obj.show_in_center = response.data[i].show_in_center
            obj.enabled = response.data[i].enabled
            obj.comment = response.data[i].comment

            data[i] = obj
          }
          console.log(data)
          this.couponData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    editCouponStatus(row) {
      request({
        url: 'coupon/' + row.id,
        method: 'patch',
        data: {
          enabled: row.enabled
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message({
            message: this.generateCustomizeString('updateFailed'),
            type: 'error'
          })
        })
    },
    editCouponShowInCenter(row) {
      request({
        url: 'coupon/' + row.id,
        method: 'patch',
        data: {
          show_in_center: row.show_in_center
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message({
            message: this.generateCustomizeString('updateFailed'),
            type: 'error'
          })
        })
    },
    handleCurrentChange(val) {
      this.fetchCouponList(val)
    }
  },
  created: function() {
    if (location.host.includes('ieshop.co.nz')) {
      const shop_domain_prefix = this.$store.state.shop.shop_domain_prefix
      this.mobileUrl = 'https://m.ieshop.co.nz/m/' + shop_domain_prefix
      if (this.pcUrl.includes('nzmai.com.cn')) {
        this.pcUrl = 'https://' + shop_domain_prefix + '.ieshop.co.nz'
      }
    }
    this.fetchCouponList(this.currentPage)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
}
.search-form-inline {
  max-height: 60px;
}
</style>
